<template>
  <div
    :id="random_id"
    :data-testid="props.dataTestid"
    v-if="builderStore?.topBrands?.length"
  >
    <TsCarouselV2
      append-class="px-0"
      :navigation="!isMobile && !isTablet"
      prev-button-class="left-1.5"
      next-button-class="right-1.5"
    >
      <TsCarouselSlide
        v-for="(item, index) in builderStore.topBrands"
        :key="item.key"
        append-class="flex-[0_0_calc(100%/2.5)] sm:flex-[0_0_calc(100%/4)] md:flex-[0_0_calc(100%/5)] lg:flex-[0_0_calc(100%/7)]"
      >
        <NuxtLinkWithLocale
          :to="`merk/${item.title.toLowerCase()}`"
          :data-testid="`brand-menu-link-to-brands-${item.title.toLowerCase()}`"
        >
          <TsCardBrandProduct
            :product-image="item.image"
            :background-color="item.bgColor"
            :product-image-brand="item.logo"
            :data-testid="`${props.dataTestid}_${item.key}`"
            @click="handleBrandCardClick(item.title)"
          />
        </NuxtLinkWithLocale>
      </TsCarouselSlide>
    </TsCarouselV2>
  </div>
</template>

<script setup lang="ts">

const TsCarouselV2 = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselV2.vue')
);

const TsCarouselSlide = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselSlide.vue')
);

const TsCardBrandProduct = defineAsyncComponent(
    () => import('~/components/organisms/TsCardBrandProduct.vue')
);

defineOptions({
  inheritAttrs: false,
});
const builderStore = useBuilderStore();
const { isMobile, isTablet } = useDevice();

type Props = {
  dataTestid?: string;
};

const props = defineProps<Props>();
const random_id = ref("");

const handleBrandCardClick = (brandName: string) => {
  useAlgoliaStore().currentActiveBrand = brandName;
  useBrandStore().handleBrandCardClick(brandName);
};

onMounted(async () => {
  random_id.value = useRandomUUID();
});
</script>
